<div class="master-modal feed_image_modal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="close-modal">
        <span (click)="dialogClose()" class="modal-close-icon"><i class="material-icons">close</i></span>
      </div>
      <div mat-dialog-content>
        <div class="modal-body">
          <div class="document-slider">
            <!-- Previous Button -->
            <button class="slider-button prev-button" (click)="previousDocument()" [style.visibility]="currentDocumentIndex === 0 ? 'hidden' : 'visible' " style="margin-left: 15px !important;">
              <i class="material-icons">chevron_left</i>
            </button>

            <!-- Document Preview -->
            <div class="document-viewer">
              <ng-container *ngIf="documents.length">
                <!-- Image -->
                <img *ngIf="isImage(documents[currentDocumentIndex]?.type, documents[currentDocumentIndex]?.mime_type)"
                  [src]="documents[currentDocumentIndex]?.url" alt="Image"
                  class="doc-preview" />

                <!-- Video -->
                <video *ngIf="isVideo(documents[currentDocumentIndex]?.type)" controls class="doc-preview">
                  <source [src]="documents[currentDocumentIndex]?.url" [type]="documents[currentDocumentIndex]?.type" />
                  Your browser does not support the video tag.
                </video>

                <!-- PDF -->
                <ngx-doc-viewer *ngIf="isPdf(documents[currentDocumentIndex]?.type, documents[currentDocumentIndex]?.mime_type)"
                  [url]="documents[currentDocumentIndex]?.url" viewer="google"
                  style="width: 100%; height: 500px;"></ngx-doc-viewer>
                  

                <ngx-doc-viewer *ngIf="isOfficeDoc(documents[currentDocumentIndex]?.type)"
                  [url]="documents[currentDocumentIndex]?.url" viewer="google"
                  style="width: 100%; height: 500px;"></ngx-doc-viewer>

                <iframe *ngIf="isText(documents[currentDocumentIndex]?.type)"
                  [src]="documents[currentDocumentIndex]?.url" class="doc-preview"
                  style="width: 600px; height: 500px; border: none;"></iframe>
              </ng-container>
              
            </div>

            <!-- Next Button -->
            <button class="slider-button next-button" (click)="nextDocument()" [style.visibility]="currentDocumentIndex === documents.length - 1 ? 'hidden' : 'visible' " style="margin-right: 15px !important;">
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
          <!-- Filename and preview icon -->
          <div class="doc-meta" *ngIf="documents.length">
            <span class="doc-name">{{ documents[currentDocumentIndex]?.name }}</span>
            <a [href]="documents[currentDocumentIndex]?.url" target="_blank" class="preview-link" title="Open in new tab">
              <i class="material-icons">open_in_new</i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>